// The scene board.contextbolt.com's sign-in wears, a different one each day,
// so coming back feels a little new. Only the dark drawn scenes: the words on
// the sign-in page are light, and drawn scenes need nothing downloaded.

import type { ThemeId } from "../../shared/types";

/** The order they come round in, every eight days. The three pixel-art scenes are spread out, so two never fall on days in a row. */
export const SIGNIN_THEMES = ["aurora", "tide", "ember", "summit", "space", "meadow", "synth", "studio"] as const satisfies readonly ThemeId[];

export type SigninTheme = (typeof SIGNIN_THEMES)[number];

/** Today's scene, by the visitor's own date: the same all day, the next one tomorrow. */
export function signinTheme(now = new Date()): SigninTheme {
  const day = Math.floor((now.getTime() - now.getTimezoneOffset() * 60_000) / 86_400_000);
  const n = SIGNIN_THEMES.length;
  return SIGNIN_THEMES[((day % n) + n) % n];
}
